import { segment } from '@actions/analytics';
import Dropdown from '@comp/Dropdown/Dropdown';
import {
  TOPIC_EDUCATOR_FILTER_CLICKED,
  TOPIC_SUBJECT_FILTER_CLICKED
} from '@constants/segment';
import styled from '@emotion/styled';
import { Spacings } from '@styles/index';
import Image from '@base/Image';
import H5 from '@base/H5/H5';
import useConstants from '@api/hooks/useConstants';
import { getIsRCPlayAllowed } from '@api/selectors/constants';

const DropdownWrapper = styled.div`
  grid-column: span 18;
  display: grid;
  grid-template-columns: repeat(18, 1fr);
  grid-column-gap: ${Spacings.SPACING_6B};
  margin-bottom: ${Spacings.SPACING_10B};
`;

const AppMessageWrapper = styled.div`
  width: 1136px;
  margin: auto;
  display: flex;
  align-items: center;
  margin-bottom: ${Spacings.SPACING_10B};
`;

const IconWrapper = styled.div`
  position: relative;
  width: 24px;
  height: 24px;
  margin-right: ${Spacings.SPACING_3B};
`;

const TopicFilters = ({
  subjectOptions,
  educatorOptions,
  onSubjectSelection,
  onEducatorSelection,
  selectedSubject,
  selectedEducator,
  goalUID
}) => {
  const handleSubjectSelect = (option) => {
    onSubjectSelection(option.value);
    segment.track(TOPIC_SUBJECT_FILTER_CLICKED, {
      subject_selected: option.value
    });
  };

  const handleEducatorSelect = (option) => {
    onEducatorSelection(option.value);
    segment.track(TOPIC_EDUCATOR_FILTER_CLICKED, {
      educator_selected: option.value
    });
  };

  const getSelectedSubject = () => {
    return subjectOptions.find((subject) => {
      return subject.value === selectedSubject;
    });
  };

  const getSelectedEducator = () => {
    return educatorOptions.find((educator) => {
      return educator.value === selectedEducator;
    });
  };

  const isRecordedContentPlayAllowed = useConstants(
    getIsRCPlayAllowed(goalUID)
  );

  return (
    <>
      <DropdownWrapper>
        <Dropdown
          // @ts-ignore
          options={subjectOptions}
          onOptionClick={handleSubjectSelect}
          selectedOption={getSelectedSubject()}
          buttonWidth="100%"
        />
        <Dropdown
          // @ts-ignore
          options={educatorOptions}
          onOptionClick={handleEducatorSelect}
          selectedOption={getSelectedEducator()}
          buttonWidth="100%"
        />
      </DropdownWrapper>
      {!isRecordedContentPlayAllowed ? <RecordedGoalAppMessage /> : null}
    </>
  );
};

const RecordedGoalAppMessage = () => {
  return (
    <AppMessageWrapper>
      <IconWrapper>
        <Image src="/gtp/app.svg" alt="benefit" layout="fill" />
      </IconWrapper>
      <H5>Lessons are only available over the Android app</H5>
    </AppMessageWrapper>
  );
};

export default TopicFilters;
